export default __webpack_public_path__ + "presentation_solitaire-6b60a46af4af2fcd40bf67e91594f807.mp4";